export const ADDRESS_DEFAULT_VALUES = {
  address: 'Carrer d Olzinelles, 72, Sants-Montjuic, 08014 Barcelona, España',
  floorNumber: '3',
  doorNumber: '1',
  building: '',
  streetName: 'Carrer d Olzinelles',
  streetNumber: '72',
  postalCode: '08014',
  city: 'Barcelona',
  province: 'Barcelona',
  provinceShortName: 'B',
  region: 'Catalunya',
  regionShortName: 'CT',
  country: 'ES',
  countryLongName: 'España',
  latitude: 41.37154990000001,
  longitude: 2.1370733,
};
